/**
 * کشور و شهر — اختیاری، از خودِ بازیکن، و فقط اگر خودش «نشان بده» را روشن کند.
 *
 * چرا از IP نمی‌سازیم: بازیکنِ ایرانی اغلب پشتِ VPN است و کشورش آلمان درمی‌آید؛
 * و چیزی که خودِ آدم انتخاب می‌کند و می‌تواند خاموش کند، از چیزی که از نشانیِ
 * شبکه‌اش بیرون کشیده شود بهتر است. فهرست‌ها آینه‌ی Backend/internal/auth/place.go
 * و Services/Place.cs در نسخه‌ی موبایل‌اند — سرور جز این‌ها را رد می‌کند.
 */

/** همه‌ی کدهای ISO 3166-1 alpha-2. */
export const COUNTRIES: readonly string[] = ("AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW").split(" ");

/** مرکزِ ۳۱ استان + چند شهرِ بزرگ. فقط با ایران. */
export const IRAN_CITIES: readonly string[] = [
  "تهران", "مشهد", "اصفهان", "کرج", "شیراز", "تبریز", "قم", "اهواز", "کرمانشاه", "ارومیه",
  "رشت", "زاهدان", "همدان", "کرمان", "یزد", "اردبیل", "بندرعباس", "اراک", "زنجان", "سنندج",
  "قزوین", "خرم‌آباد", "گرگان", "ساری", "شهرکرد", "بجنورد", "بیرجند", "ایلام", "بوشهر", "سمنان",
  "یاسوج", "کیش", "قشم", "کاشان", "نجف‌آباد", "دزفول", "آبادان", "بابل", "آمل", "نیشابور",
];

let names: Intl.DisplayNames | null | undefined;

/** نامِ فارسیِ کشور از خودِ مرورگر؛ اگر نداشت، همان کد. */
export function countryName(code: string): string {
  if (!code) return "";
  if (names === undefined) {
    try { names = new Intl.DisplayNames(["fa"], { type: "region" }); } catch { names = null; }
  }
  try { return names?.of(code) ?? code; } catch { return code; }
}

/** فهرستِ کشورها برای انتخاب: ایران اول، بقیه به ترتیبِ نامِ فارسی. */
export function countryOptions(): { code: string; fa: string }[] {
  const rest = COUNTRIES.filter((c) => c !== "IR").map((code) => ({ code, fa: countryName(code) }));
  rest.sort((a, b) => a.fa.localeCompare(b.fa, "fa"));
  return [{ code: "IR", fa: countryName("IR") }, ...rest];
}

/**
 * برچسبِ کوتاهِ جا کنارِ نام: شهر اگر گفته باشد، وگرنه کشور. «شیراز» به‌تنهایی
 * گویاست — همه می‌دانند شیراز کجاست — و کوتاه‌تر از «شیراز، ایران».
 */
export function placeLabel(p: { country?: string; city?: string }): string {
  if (p.city) return p.city;
  return p.country ? countryName(p.country) : "";
}
